import { Route, Switch } from "react-router-dom"

// Sets global variables and completes other setup steps
require("lib/technical/AppInit")

var Auth = require("lib/technical/RouteAuth");

var App = require("components/technical/App");

var AppdevHomePage = require("components/appdev/AppdevHomePage");
var ScreenshotDataPage = require("components/appdev/ScreenshotDataPage");
var WarmupQuestionDisplayPage = require("components/appdev/WarmupQuestionDisplayPage");
var PowerDrillPage = require("components/appdev/wizards/PowerDrillPage");

var NewDealPage = require("components/appdev/crm/NewDealPage");
var NewQuotesPage = require("components/appdev/crm/NewQuotesPage");
var DealReceivedPage = require("components/appdev/crm/DealReceivedPage");
var NewSchoolOrgPage = require("components/appdev/crm/NewSchoolOrgPage");
var NewSchoolPage = require("components/appdev/crm/NewSchoolPage");
var UpgradeTokenPage = require("components/appdev/crm/UpgradeTokenPage");
var DiscountTokenPage = require("components/appdev/crm/DiscountTokenPage");
var DealTransformsPage = require("components/appdev/crm/DealTransformsPage");

var UserDetailsPage = require("components/appdev/wizards/UserDetailsPage");
var MergeStudentsPage = require("components/appdev/wizards/MergeStudentsPage");
var DigestsPage = require("components/appdev/wizards/DigestsPage");
var SchoolOrgListPage = require("components/appdev/wizards/SchoolOrgListPage");
var SchoolOrgDetailsPage = require("components/appdev/wizards/SchoolOrgDetailsPage");
var DistrictOrgListPage = require("components/appdev/wizards/DistrictOrgListPage");
var DistrictOrgDetailsPage = require("components/appdev/wizards/DistrictOrgDetailsPage");
var DirectSchoolOrgCreationPage = require("components/appdev/wizards/DirectSchoolOrgCreationPage");

var CleverAccessTokenDetailsPage = require("components/appdev/wizards/CleverAccessTokenDetailsPage")

var LoginPage = require("components/logins/LoginPage");

module.exports = (
	<App>
		<Switch>
			<Route exact path="/"								component={ Auth.AllAccess(AppdevHomePage) } />
			<Route exact path="/screenshot_data"				component={ Auth.Wizards(ScreenshotDataPage) } />
			<Route exact path="/warmup_display"					component={ Auth.Wizards(WarmupQuestionDisplayPage) } />

			<Route path="/new_deal"								component={ Auth.Wizards(NewDealPage) } />
			<Route path="/new_quotes"							component={ Auth.Wizards(NewQuotesPage) } />
			<Route path="/received"								component={ Auth.Wizards(DealReceivedPage) } />
			<Route path="/new_school_org"						component={ Auth.Wizards(NewSchoolOrgPage) } />
			<Route path="/new_school"							component={ Auth.Wizards(NewSchoolPage) } />
			<Route path="/direct_school_org"					component={ Auth.Wizards(DirectSchoolOrgCreationPage) } />
			<Route path="/upgrade_tokens"						component={ Auth.Wizards(UpgradeTokenPage) } />
			<Route path="/discount_tokens"						component={ Auth.Wizards(DiscountTokenPage) } />
			<Route path="/deal_transforms"						component={ Auth.Wizards(DealTransformsPage) } />

			<Route path="/users/search"							component={ Auth.Wizards(PowerDrillPage) } />
			<Route path="/users/:id/details"					component={ Auth.Wizards(UserDetailsPage) } />
			<Route path="/merge_students"							component={ Auth.Wizards(MergeStudentsPage) } />
			<Route path="/digests_page"							component={ Auth.Wizards(DigestsPage) } />

			<Route path="/school_orgs/:id/details/:active_view"	component={ Auth.Wizards(SchoolOrgDetailsPage) } />
			<Route path="/school_orgs"							component={ Auth.Wizards(SchoolOrgListPage) } />
			
			<Route path="/district_orgs/:id/details/:active_view"	component={ Auth.Wizards(DistrictOrgDetailsPage) } />
			<Route path="/district_orgs"						component={ Auth.Wizards(DistrictOrgListPage) } />
			
			<Route path="/clever_access_tokens/:id/details"	component={ Auth.Wizards(CleverAccessTokenDetailsPage) } />
			
			<Route path="/login" 								component={ Auth.LoggedOut(LoginPage) } />
		</Switch>
	</App>
);



// WEBPACK FOOTER //
// ./modules/routes_appdev.js